import React, { useRef } from "react";
import { IonList } from "@ionic/react";

import {
  IRealization,
  ITeacherGearbox,
  IPagyInfo,
  IOnClickStudentAvatarParams,
} from "../../../state";
import RealizationItem from "../../../molecules/teacher/RealizationItem";
import BoxItem from "../../../atoms/BoxItem";
import useIntersection from "../../../hooks/useIntersection";

import styles from "./BoxDetail.module.scss";

export interface BoxDetailProps {
  isDisplaying: boolean;
  calling: boolean;
  gearbox: ITeacherGearbox | null;
  realizations: IRealization[];
  pagy_info: IPagyInfo;
  fetchRealizations: (page?: number) => void;
  onAction: (realizationId: number) => void;
  showStudentDetail: (params: IOnClickStudentAvatarParams) => void;
  addFavorite: (id: number) => void;
  removeFavorite: (id: number) => void;
}

const BoxDetail: React.FC<BoxDetailProps> = ({
  isDisplaying,
  calling,
  gearbox,
  realizations,
  pagy_info,
  fetchRealizations,
  onAction,
  showStudentDetail,
  addFavorite,
  removeFavorite,
}) => {
  const loadMoreRef = useRef<HTMLDivElement>(null);

  useIntersection({
    target: loadMoreRef,
    enabled: isDisplaying && !calling && pagy_info.page < pagy_info.pages,
    onIntersect: () => fetchRealizations(pagy_info.page + 1),
  });

  return (
    <div className={styles.wrapper}>
      <BoxItem
        className={styles.boxInfo}
        realizationsCount={gearbox?.realizations_count ?? 0}
        isArchived={!!gearbox?.is_archived}
        isSubmissionPrivate={!!gearbox?.is_submission_private}
        nameStatus={gearbox?.name_status ?? "unpublish"}
        title={gearbox?.title ?? "ー"}
        year={gearbox?.year}
        isSubjectBox={!!gearbox?.subject_id}
        boxTemplate={
          gearbox?.template ?? {
            id: 0,
            title: "",
            description: "",
            content: "",
            boxes: [],
          }
        }
        boxAssignedTeachers={gearbox?.assigned_teachers}
      />
      <IonList className={styles.itemList}>
        {realizations.map(realization => (
          <RealizationItem
            key={realization.id}
            realization={realization}
            hideCheckedStatus
            onClick={() => onAction(realization.id)}
            onAvatarClick={showStudentDetail}
            addFavorite={addFavorite}
            removeFavorite={removeFavorite}
          />
        ))}
        <div className={styles.loadMore} ref={loadMoreRef}>
          {calling ? "読み込み中" : ""}
        </div>
      </IonList>
    </div>
  );
};

export default BoxDetail;
